{
  "appName": "Al-Musafer",
  "platform": "Platform",
  "name": "Name",
  "email": "Email",
  "phone": "Phone",
  "address": "Address",
  "actions": {
    "save": "Save",
    "cancel": "Cancel",
    "delete": "Delete",
    "edit": "Edit",
    "create": "Create",
    "search": "Search",
    "retry": "Retry",
    "close": "Close",
    "confirm": "Confirm"
  },
  "nav": {
    "dashboard": "Dashboard",
    "users": "Users",
    "settings": "Settings",
    "logout": "Log out"
  },
  "language": {
    "label": "Language",
    "ar": "العربية",
    "en": "English",
    "switchTo": {
      "ar": "Switch to Arabic",
      "en": "Switch to English"
    }
  },
  "theme": {
    "switchToLight": "Switch to light mode",
    "switchToDark": "Switch to dark mode"
  },
  "preferences": {
    "label": "Language and appearance settings"
  },
  "state": {
    "loading": "Loading…",
    "empty": "No data",
    "error": "Something went wrong"
  },
  "notFound": {
    "title": "Page not found",
    "description": "Check the address, or go back to a page you can reach.",
    "action": "Go to the portal"
  },
  "sidebar": {
    "toggle": "Toggle sidebar",
    "title": "Sidebar",
    "description": "Navigate between the system pages"
  },
  "breadcrumb": {
    "label": "Breadcrumb",
    "more": "More"
  },
  "toaster": {
    "label": "Notifications"
  },
  "pagination": {
    "label": "Pagination",
    "morePages": "More pages",
    "page": "Page {{page}} of {{totalPages}}",
    "total": "{{total}} records",
    "next": "Next",
    "previous": "Previous"
  },
  "combobox": {
    "placeholder": "Select...",
    "search": "Search...",
    "empty": "No results",
    "clearOption": "None",
    "clearSelection": "Clear selection",
    "removeSelection": "Remove {{label}}",
    "selectedCount_one": "{{count}} selected",
    "selectedCount_two": "{{count}} selected",
    "selectedCount_few": "{{count}} selected",
    "selectedCount_many": "{{count}} selected",
    "selectedCount_other": "{{count}} selected"
  },
  "filterToolbar": {
    "phoneCountryCode": "Country code",
    "toggle": "Filters",
    "resetFilters": "Reset filters"
  },
  "password": {
    "show": "Show password",
    "hide": "Hide password"
  }
}
